'use client';
import {Chip, SoldOutLabel} from '../../primitives';
import {statusBadgeIcon} from '../meta-icons';

export interface CardStatusChipProps {
  statusKey: string;
  label: string;
}

export function CardStatusChip({statusKey, label}: CardStatusChipProps) {
  if (statusKey === 'sold_out') {
    return <SoldOutLabel label={label} />;
  }
  return (
    <Chip color="dark" size="medium" iconLeft={statusBadgeIcon(statusKey)}>
      {label}
    </Chip>
  );
}

CardStatusChip.displayName = 'CardStatusChip';
